<template>
    <div class="w-full">
        <div class="flex items-start justify-between">
            <div class="mt-0.5 pr-3">
                <span class="font-bold text-info cursor-pointer"
                      @mousedown="goToRoute($event, 'Contract Details', { idSite: siteId, contractId: contract.id })">
                    {{ contract.number }}
                </span>
                - {{ hasInterventionPlan(contract) ? contract.intervention_plan.is_updating ? 'Informations indisponibles. Plan d\'intervention en cours de modifications.' : contractInterventionTypes(contract.intervention_plan.planning_intervention_groups).join(', ') : 'Plan d\'intervention indisponible' }}
            </div>
            <div v-if="hasInterventionPlan(contract)" class="flex items-center pr-0.5 min-w-max">
                <span class="mt-0.5">{{ contract.intervention_plan.is_updating ? '0' : contract.countDevices }} dispositifs</span>
                <div class="ml-4">
                    <md-button class="md-icon-button md-default" @click="toggleDevices">
                        <font-awesome-icon class="md-icon" :icon="['fa', this.showDevices ? 'minus-circle' : 'plus-circle']" />
                    </md-button>
                </div>
            </div>
        </div>
        <template v-if="contract.last_period.is_canceled">
            <span class="text-danger">Sera résilié le : {{ $moment(contract.last_period.cancel_date).format('DD/MM/YYYY') }}</span>
        </template>
        <template v-if="hasInterventionPlan(contract)">
            <div :id="contract.id + '-interventions'" v-if="!contract.intervention_plan.is_updating">
                <p class="mb-0 font-bold">Interventions</p>
                <div class="md-layout">
                    <div class="md-layout-item md-size-50 pl-0" v-for="month in contract.interventions" :key="month.month">
                        <span class="font-normal">{{ month.label }} :</span>
                        <span class="ml-1">{{ month.count }} inter ({{ hoursAndMinutes(month.duration) }})</span>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="showDevices">
            <p class="mb-0 mt-2 font-bold">Dispositifs</p>
            <template v-if="!contract.intervention_plan.is_updating && Object.keys(contract.deviceTypes).length > 0">
                <div class="md-layout">
                    <div class="md-layout-item md-size-50 pl-0" v-for="deviceType in contract.deviceTypes" :key="deviceType.id">
                        <span class="font-normal">{{ deviceType.count }} :</span>
                        <span class="ml-1">{{ deviceType.name }}</span>
                    </div>
                </div>
            </template>
            <p v-else class="mb-0">
                {{ contract.intervention_plan.is_updating ? 'Dispositifs indisponibles. PI en cours de modification.' : 'Aucun dispositif disponible' }}
            </p>
        </template>
    </div>
</template>

<script>
import routerMixin from '@/mixins/router-mixin'

export default {
    name: "ContractDetails",
    mixins: [routerMixin],
    props: {
        siteId: Number,
        contract: Object
    },
    data() {
        return {
            showDevices: false,
        }
    },
    methods: {
        toggleDevices() {
            this.showDevices = !this.showDevices
        },
        hasInterventionPlan(contract) {
            return !!contract.intervention_plan
        },
        hoursAndMinutes(duration) {
            let hours = Math.floor((duration / 60))
            let minutes = duration - (hours * 60)
            hours = hours !== 0 ? hours + 'h' : ''
            minutes = minutes !== 0 ? minutes + 'm' : ''
            return `${hours}${minutes}`
        },
        contractInterventionTypes(interventionGroups = []) {
            return interventionGroups.map(group => { return group.intervention_type.name })
        },
    }
}
</script>

<style scoped>

</style>
